export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Site/Login"),
    meta: { title: "登录" },
  },
  {
    path: "/login1",
    name: "Login1",
    component: () => import("@/views/Site/Login1"),
    meta: { title: "登录" },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Site/Register"),
    meta: { title: "注册" },
  },
  {
    path: "/registerCode",
    name: "RegisterCode",
    component: () => import("@/views/Site/RegisterCode"),
    meta: { title: "注册" },
  },
  {
    path: "/reset",
    name: "Reset",
    component: () => import("@/views/Site/Reset"),
    meta: { title: "找回密码" },
  },
  {
    path: "/resetCode",
    name: "resetCode",
    component: () => import("@/views/Site/ResetCode"),
    meta: { title: "找回密码" },
  },
  {
    path: "/scoutAround",
    name: "ScoutAround",
    component: () => import("@/views/Site/ScoutAround"),
    meta: { title: "搜索" },
  },
];



// WEBPACK FOOTER //
// ./src/router/config/SiteRouter.js